import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useAuthModal } from "../context/authModalContext";

const PrivateRoute = ({ children }) => {
  // Gate on the user's identity token, not the DMS service token — see
  // AdminPrivateRoute for the rationale.
  const isAuthenticated = !!localStorage.getItem("vizy-identity-token");
  const { openModal } = useAuthModal();

  useEffect(() => {
    if (!isAuthenticated) openModal("login");
  }, [isAuthenticated, openModal]);

  return isAuthenticated ? children : <Navigate to="/" replace />;
};

export default PrivateRoute;
